import { Outlet } from "react-router-dom";
import SmoothScrollProvider from "@/components/layout/SmoothScrollProvider";
import NavbarPublic from "@/components/layout/NavbarPublic";
import Footer from "@/components/sections/Footer";
import { Toaster } from "sonner";

const PublicLayout = () => {
  return (
    <SmoothScrollProvider>
      <div className="min-h-screen bg-lenvia-bg flex flex-col">
        <a
          href="#main-content"
          className="skip-link"
        >
          Aller au contenu principal
        </a>
        <NavbarPublic />
        <main id="main-content" tabIndex={-1} className="flex-grow">
          <Outlet />
        </main>
        <Footer />
        <Toaster
          position="top-right"
          richColors
          theme="dark"
          toastOptions={{
            style: {
              background: "#0B0D14",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              color: "#F8FAFC",
            },
          }}
        />
      </div>
    </SmoothScrollProvider>
  );
};

export default PublicLayout;
